import styled, { css } from "styled-components"

import { when, maxWidth, minWidth } from "utils"

// due to Ceros iFrame issue with flex container, only making flex if there is a button
export const TextAndButtonContainer = styled.div`
  display: ${({ hideOnPageLoad, hasButton }) =>
    hideOnPageLoad ? "none" : hasButton ? "flex" : "block"};
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  ${when("hasButton")`
    padding-bottom: 8rem;
  `}

  ${when("inGrid")`
    height: 100%;
    justify-content: space-between;
    padding-bottom: 2rem;
    color: ${({ theme }) => theme.component.text};
    background-color: ${({ theme }) => theme.component.background};
  `}

  ${({ isPromotionalPlacement }) =>
    isPromotionalPlacement &&
    css`
      ${minWidth.desktop`
        margin-bottom: 4rem;
        border: 0.3rem solid #f3f3f3;
      `}

      ${maxWidth.mobile`
        border-top: 0.3rem solid #f3f3f3;
        border-bottom: 0.3rem solid #f3f3f3;
        margin-bottom: 4rem;
    `}
    `}
`
export const Container = styled.section`
  margin: 0 auto;
  padding: 8rem 0;

  // this code is needed to support custom code at 100%
  ${when("isPromotionalPlacement")`
    width: 100%;
  `}

  ${when("hasButton")`
    padding: 8rem 0 4rem;
  `}

  padding-left: calc((100% - 74rem) / 2);
  padding-right: calc((100% - 74rem) / 2);
  font-size: 1.8rem;
  line-height: 1.4;
  color: ${({ theme }) => theme.component.text};
  background-color: ${({ theme }) => theme.component.background};
  > :first-child {
    margin-top: 0;
  }
  > :last-child {
    margin-bottom: 0;
  }
  h1 {
    text-align: center;
    margin-bottom: 3rem;
    color: ${({ theme }) => theme.component.largeHeading};
    ${({ theme }) => {
      switch (theme.component.sectionHeading) {
        case "Type C":
        case "Type D":
          return css`
            font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
            font-size: ${theme.component.sectionHeading === "Type C" ? "4.4rem" : "3.6rem"};
            font-weight: 400;
            ${maxWidth.mobile`
              font-size: ${theme.component.sectionHeading === "Type C" ? "3.6rem" : "3.4rem"};
            `}
          `
        default:
          return css`
            font-size: 3.5rem;
            ${maxWidth.mobile`
               font-size: 2.6rem;
             `}
          `
      }
    }}
  }
  h2 {
    font-size: 2.2rem;
    line-height: 140%;
    margin: 4rem 0 3rem;
    color: ${({ theme }) => theme.component.largeHeading};
  }
  a {
    text-decoration: underline;
    font-weight: medium;
    color: ${({ theme }) => theme.component.highlight};
  }
  table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    th,
    td {
      border: 1px solid #222;
      vertical-align: top;
      padding: 0.5rem;
    }
    td {
      font-size: 1.6rem;
    }
  }
  ${maxWidth.tablet`
    ${({ theme }) =>
      !theme.component.isNested &&
      `
        padding-left: 2rem;
        padding-right: 2rem;
      `}
      overflow-wrap: break-word;
    `}
  ${({ theme }) =>
    theme.component.isNested &&
    `
      padding: 0;
      padding-left: 0;
      padding-right: 0;
      margin: 0;
    `}
  ${when("noPadding")`
    padding: 0;
    text-align: center;
  `}
  ${when("inGrid")`
    padding: 4rem 2rem;
    text-align: center;
  `}
`
